<h2 mat-dialog-title>{{ data.dataItem?.unit }}</h2>
<mat-dialog-content>
  <div>{{ displayStart }} - {{ displayEnd }}</div>
  @if (detailData) {
    <div class="reports-container">
      <kendo-grid
        #bridgeActionDetailGrid="kendoGrid"
        class="col-12 mt-3 usage-grid"
        [kendoGridBinding]="detailData.data"
        [navigable]="true"
      >
        <ng-template kendoGridToolbarTemplate>
          <kendo-grid-spacer />
          <button
            type="button"
            matButton
            (click)="exportToExcel(bridgeActionDetailGrid)"
          >
            Export to Excel
          </button>
          <button
            type="button"
            matButton
            (click)="exportToPDF(bridgeActionDetailGrid)"
          >
            Export to PDF
          </button>
        </ng-template>
        @for (col of detailData.headers; track $index) {
          <kendo-grid-column
            [field]="col.DataField"
            [title]="col.Label"
            [hidden]="col.Hidden"
          />
        }
        <kendo-grid-pdf
          fileName="{{ data.dataItem?.unit }}_Actions.pdf"
          [repeatHeaders]="true"
        />
        <kendo-grid-excel fileName="{{ data.dataItem?.unit }}_Actions.xlsx" />
      </kendo-grid>
    </div>
  }
  @if (loading) {
    <app-simple-loading [message]="'Loading Data...'" />
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button type="button" mat-raised-button mat-dialog-close>Close</button>
</mat-dialog-actions>
